import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleGate = ({ allow, children }) => {
    const { user, ready } = useAuth();

    if (!ready) {
        return <div className="loading-screen">Cargando...</div>;
    }
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    if (allow && !allow.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default RoleGate;
